import React, { useCallback, useEffect, useState } from "react";
import classNames from "classnames";
import { Dispatch } from "redux";
import { useDispatch, useSelector } from "react-redux";

import stylesForm from "../../../assets/styles/form.module.scss";
import styles from "../chat-folder.module.scss";
import DefaultModal from "../../default-modal/default-modal.component";
import { ChatFolderModalState } from "../chat-folder.types";

import { setChatSelectFolderSettingModalIsOpen } from "~/app/modals/modals.actions";
import { selectChangeFolderAction, selectDeleteFolderAction } from "~/app/chat/folders/folders.actions";
import { ApplicationStore } from "~/app/application.store";

const ChatSelectedFolderSettingComponent: React.FC = () => {
  const dispatch: Dispatch<any> = useDispatch();

  const isOpenChatFolderSettingModal: boolean = useSelector(
    (state: ApplicationStore) => state.modals.setChatSelectFolderSettingModalIsOpen
  );
  const currentFolder: ChatFolderModalState | null = useSelector(
    (state: ApplicationStore) => state.chatFolders.currentFolder
  );

  const [chatFolderSettingData, setChatFolderSettingData]: [
    ChatFolderModalState,
    React.Dispatch<React.SetStateAction<ChatFolderModalState>>
  ] = useState<ChatFolderModalState>({
    title: "",
    position: 0,
    isGeneral: true
  });

  useEffect(() => {
    setChatFolderSettingData(currentFolder ? { ...currentFolder } : { title: "", position: 0, isGeneral: true });
  }, []);

  const handleChatSelectFolderSettingModalIsOpen: (isOpen: boolean) => void = useCallback(
    (isOpen: boolean): void => {
      dispatch(setChatSelectFolderSettingModalIsOpen(isOpen));
    },
    [dispatch]
  );
  const handleSelectChangeFolderAction: (folder: ChatFolderModalState) => void = useCallback(
    (folder: ChatFolderModalState) => {
      dispatch(selectChangeFolderAction(folder));
    },
    [dispatch]
  );
  const handleSelectDeleteFolderAction: (folder: ChatFolderModalState) => void = useCallback(
    (folder: ChatFolderModalState) => {
      dispatch(selectDeleteFolderAction(folder));
    },
    [dispatch]
  );

  const handleChange: (target: { name: string; value: string; type: string }) => void = (target: {
    name: string;
    value: string;
    type: string;
  }): void => {
    if (target.type === "radio" && target.name === "folderState") {
      if (target.value == "isGeneral") {
        setChatFolderSettingData({ ...chatFolderSettingData, isGeneral: true, isPrivate: false });
      } else {
        setChatFolderSettingData({ ...chatFolderSettingData, isGeneral: false, isPrivate: true });
      }
    } else {
      setChatFolderSettingData({ ...chatFolderSettingData, [target.name]: target.value });
    }
  };

  const handleChangeChatFolder: () => void = (): void => {
    if (chatFolderSettingData.title !== "") {
      handleSelectChangeFolderAction(chatFolderSettingData);
    }
  };

  const handleDeleteChatFolder: () => void = (): void => {
    handleSelectDeleteFolderAction(chatFolderSettingData);
  };

  return (
    <DefaultModal
      title="Change Folder"
      modalState={isOpenChatFolderSettingModal}
      setModalState={handleChatSelectFolderSettingModalIsOpen}
      action={handleChangeChatFolder}
      actionDelete={handleDeleteChatFolder}
    >
      <div className={styles.row}>
        <div className={classNames(stylesForm.inputGroup, styles.colMd8)}>
          <input
            name="title"
            onChange={(e): void => handleChange(e.target)}
            placeholder="Title"
            value={chatFolderSettingData.title}
          />
        </div>
        <div className={classNames(stylesForm.inputGroup, styles.colMd4)}>
          <input
            name="position"
            type="number"
            onChange={(e): void => handleChange(e.target)}
            value={chatFolderSettingData.position}
            placeholder="Position"
          />
        </div>
      </div>
      <div className={stylesForm.inputGroup}>
        <label className={stylesForm.radioWrapper}>
          <input
            type="radio"
            name="folderState"
            value="isGeneral"
            checked={chatFolderSettingData.isGeneral ?? false}
            onChange={(e): void => handleChange(e.target)}
          />
          <span>Folder General</span>
        </label>
        <label className={stylesForm.radioWrapper}>
          <input
            type="radio"
            name="folderState"
            value="isPrivate"
            checked={chatFolderSettingData.isPrivate ?? false}
            onChange={(e): void => handleChange(e.target)}
          />
          <span>Folder Private</span>
        </label>
      </div>
    </DefaultModal>
  );
};

export default ChatSelectedFolderSettingComponent;
